export const isFirstChildAnchor = (node: Node): node is HTMLAnchorElement => {
  return node && node.nodeType === Node.ELEMENT_NODE && (node as HTMLElement).tagName === "A";
};

export const tooltipContent = (Host: HTMLOcButtonV1Element): string => {
  let content = "";

  if (isFirstChildAnchor(Host.children[0])) {
    content = Host.children[0].innerHTML;
  } else {
    content = Host.innerHTML;
  }

  return `<div aria-hidden="true" slot="tooltip-content">${content}</div>`;
};
